import { } from '@angular/common/http';
import { HostListener } from '@angular/core';
import { Component } from '@angular/core';
import { AuthService } from './services/auth.service';
import { PrimeNG } from 'primeng/config';
// import { PrimeNGConfig } from 'primeng/api';

@Component({
    selector: 'app-component',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})


export class AppComponent {

  ngOnInit(): void {

    this.config.setTranslation({
      accept: 'Aceptar',
      reject: 'Cancelar',
      emptyFilterMessage: 'Sin registros',
      dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      equals: 'Igual a',
      notEquals: 'Diferente de',
      lt: 'Menor que',
      lte: 'Menor igual que',
      gt: 'Mayor que',
      gte: 'Mayor igual que',
      addRule: 'Agregar regla',
      clear: 'Limpiar',
      apply: 'Aplicar',
      strong: 'Fuerte',
      medium: 'Medio',
      weak: 'Débil',
      passwordPrompt: 'Ingrese una contraseña.',
      contains: 'Contiene',
      notContains: 'No contiene',
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      //translations
      today: "Hoy",
      startsWith: "Inicia en",
      endsWith: "Termina en",
      matchAll: "Todos",
      matchAny: "Cualquiera"
    });
  }
  userLogged = false;
  title = 'ComercialWeb';
  /*constructor (private readonly injector: Injector){

  const user : any = this.injector.get(UserRepository)//Para llamar instancias que ya estan creadas
  this.userLogged = user.userLogged;
  user.onchangeStatusUser.subscribe((status:boolean) => this.userLogged = status)

  }
  */
  private inactivityTimeout: any; // Corrección del tipo de variable
  ; // Almacena el identificador del temporizador de inactividad
  readonly inactivityDuration = 28800000 // 8 horas//7200000; // Duración de inactividad en milisegundos (30 minutos)

  constructor(private readonly auth: AuthService, private config: PrimeNG) {

    this.resetInactivityTimer()
    this.auth
      .getChangeStatusUser()
      .subscribe((status: boolean) => (this.userLogged = status));



    if (this.userLogged === false) {

      this.userLogged = auth.getListaUseSession()

    }

  }


  // Reinicia el temporizador de inactividad en respuesta a eventos de actividad del usuario
  @HostListener('window:mousemove', ['$event'])
  @HostListener('window:keypress', ['$event'])
  resetInactivityTimer() {
    clearTimeout(this.inactivityTimeout);

    // Establece el temporizador para cerrar la sesión después de la duración de inactividad especificada
    this.inactivityTimeout = setTimeout(() => {
      // Lógica para cerrar la sesión aquí (por ejemplo, llamada a la API de cierre de sesión)
      // Puedes mostrar una notificación al usuario antes de cerrar la sesión
      this.auth.logout()

    }, this.inactivityDuration);
  }

}
